export default "__VITE_ASSET__DkSqNo0q__"